import map from "lodash/map";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getBybetjenter } from "../../../actions/bybetjenterActions";
import * as title from "../../../constants/titles";
import {
    toNorwegianDateFormat,
    toNorwegianDatetime,
} from "../../../utils/date";
import Table from "../../Common/Tables/BaseTable";
import BypatruljeteamHistorikkModal from "./BypatruljeTeamHistorikk";
import BybetjenterUpdateModal from "./UpdateModals/Bybetjent";

const headerRow = [
  "Tjenestesnummer",
  "Team",
  "Navn",
  "Mobilnummer",
  "E-post",
  "Start dato",
  "Slutt dato",
  "Rolle",
  "Seksjon",
  "",
];

export default function BybetjentList({ authorizedToCreateAndEdit }) {
  const dispatch = useDispatch();
  const bybetjenter = useSelector((state) => state.bybetjenter);

  useEffect(() => {
    document.title = title.grunndataBupatruljen;
    dispatch(getBybetjenter());
  }, [dispatch]);

  const renderBetjentTeam = (team) => {
    if (team && team.length > 0) {
      return team.map((i) => (
        <div key={i.navn}>
          {i.navn}
          <br />
        </div>
      ));
    }
    return "";
  };

  return (
    <Table
      id="bybetjent-liste"
      className="table-wrapper-horizontal-scroll-white-space-normal"
      headerRow={headerRow}
      defaultStyle
      striped
    >
      <tbody>
        {map(bybetjenter, (bybetjent) => (
          <tr key={`bybetjenterTableBodyTr${bybetjent.id}`}>
            <td>
              <BypatruljeteamHistorikkModal
                bybetjentId={bybetjent.id}
                tjenestenummer={bybetjent.nummer}
                team={bybetjent.teamer}
              />
            </td>
            <td>{renderBetjentTeam(bybetjent.team)}</td>
            <td>{bybetjent.navn}</td>
            <td>{bybetjent.mobil}</td>
            <td>{bybetjent.epost}</td>
            <td>
              {toNorwegianDateFormat(toNorwegianDatetime(bybetjent.aktivertDato))}
            </td>
            <td>
              {toNorwegianDateFormat(toNorwegianDatetime(bybetjent.deaktivertDato))}
            </td>
            <td>{bybetjent.rolle ? bybetjent.rolle.navn : ""}</td>
            <td>{bybetjent.seksjon ? bybetjent.seksjon.navn : ""}</td>
            <td>
              {authorizedToCreateAndEdit && (
                <BybetjenterUpdateModal
                  id={bybetjent.id}
                  nummer={bybetjent.nummer}
                  team={bybetjent.team}
                  navn={bybetjent.navn}
                  mobil={bybetjent.mobil}
                  epost={bybetjent.epost}
                  rolle={bybetjent.rolle ? bybetjent.rolle.id : 0}
                  seksjon={bybetjent.seksjon ? bybetjent.seksjon.id : 0}
                  aktivertDato={bybetjent.aktivertDato}
                  deaktivertDato={bybetjent.deaktivertDato}
                />
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

